<div class="text-center d-flex align-items-center justify-content-center p-2">
  <button class="btn btn-link" (click)="toggleShowAll()">
    <span class="font-weight-bold text-tertiary">{{ !showAll ? ('BUTTONS.SHOW_ALL' |translate) : ('BUTTONS.SHOW_LESS' |translate) }}</span>
    @if (!showAll && numberOfElements) {
      <span class="font-weight-bold text-tertiary ml-1">({{ numberOfElements }})</span>
    }
    <i class="fas font-weight-bold text-tertiary ml-1 {{ !showAll ? 'fa-chevron-down' : 'fa-chevron-up' }}"></i>
  </button>
</div>